import { subPartyMonthUpdateApi } from "../../api/subPartyMonth/subPartyMonthUpdateApi"

type PayloadShape = Parameters<typeof subPartyMonthUpdateApi>[0]

export async function subPartyMonthUpdateService(payload: PayloadShape, token: string) {
	return await subPartyMonthUpdateApi(payload, token)
}
